import {
  Button,
  Dialog,
  Grid,
  Typography,
  useMediaQuery,
  Box,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { ExpandLessOutlined, ExpandMoreOutlined } from '@mui/icons-material';
import 'index.css';
import React, { useState } from 'react';
import { poppins500, poppins400 } from 'theme/common.style';
import { SpinnerCircle } from 'component/BuyersMarketplace/Marketplaceicons';
import { Pendingwarning } from 'component/BuyersMarketplace/MakeOffers';
import { useTheme } from '@emotion/react';
import { WarningIconYELLOW } from './PrivateOfferDetails';
import PrivateOfferAcceptPopupTwo from './PrivateOfferAcceptPopupTwo';

const PrivateOfferAcceptPopupOne = ({
  open,
  onClose,
  getBuyerIndividualValue,
  setPrivateOfferDetailsOpen,
  setManageOffer,
  groupIt,
  groupCall,
}) => {
  const [firstChecked, setFirstChecked] = useState(false);
  const [secondChecked, setSecondChecked] = useState(false);
  const [privateOfferAcceptOpenTwo, setPrivateOfferAcceptOpenTwo] =
    useState(false);
  const theme = useTheme();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const matches600 = useMediaQuery(theme.breakpoints.down(600));
  const matches750 = useMediaQuery(theme.breakpoints.down(750));
  const matches800 = useMediaQuery(theme.breakpoints.down(850));
  const isXsScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const isSmallHeight = useMediaQuery('(max-height:700px)');
  const [showOfferSummary, setShowOfferSummary] = useState(true);
  const handleToggle = () => {
    setShowOfferSummary((prev) => !prev);
  };
  const flexStyle = { display: 'flex', alignItems: 'center', gap: '15px' };
  const reqStyle = {
    fontFamily: 'poppins',
    color: '#666666',
    whiteSpace: matches600 ? 'nowrap' : 'wrap',
    fontSize: matches750 ? '14px' : '16px',
    width: '30%',
  };

  const CustomCheckIcon = (
    <span
      style={{
        display: 'inline-block',
        width: 30,
        height: 20,
        borderRadius: 4,
        backgroundColor: '#d9d9d9',
        border: '1px solid #d9d9d9',
      }}
    />
  );

  const CustomCheckedIcon = (
    <span
      style={{
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 30,
        height: 20,
        borderRadius: 4,
        backgroundColor: '#4CA4D6',
      }}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 6L9 17L4 12"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          sx: {
            height: 'auto',
            borderRadius: '8px',
            boxShadow: '-4px 4px 8px rgba(0, 0, 0, 0.09)',
            padding: matchesmd ? '30px 20px' : '30px',
            minWidth: matches800 ? '95%' : '721px',
          },
        }}
      >
        <Grid container>
          <Grid item>
            <Typography
              sx={{
                fontFamily: 'poppins!important',
                fontSize: matchesmd ? '10px' : '14px!important',
                fontWeight: 400,
                color: '#666666',
              }}
            >
              {
                getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                  ?.streetName
              }
            </Typography>

            <Grid
              item
              display={'flex'}
              alignItems={'center'}
              padding={'12px 0px 15px 0'}
            >
              <Pendingwarning matchesmd={matchesmd} />
              <Typography
                sx={{
                  ...poppins500,
                  fontSize: matchesmd ? '16px' : '24px',
                  paddingLeft: '12px',
                  color: '#000000',
                }}
              >
                Private Offer Acceptance
              </Typography>
            </Grid>

            <Grid>
              <Typography
                sx={{
                  paddingTop: '8px',
                  fontFamily: 'poppins!important',
                  fontSize: matchesmd ? '12px' : '16px!important',
                  fontWeight: 400,
                  color: '#666666',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                You are about to accept the Private Offer from the agent. Please
                review the terms carefully before proceeding.
              </Typography>
              <br />
              <br />
              <Typography
                sx={{
                  paddingTop: '8px',
                  fontFamily: 'poppins!important',
                  fontSize: matchesmd ? '12px' : '16px!important',
                  fontWeight: 400,
                  color: '#666666',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                Acceptance may bind you to complete the purchase under the
                stated conditions.
              </Typography>
            </Grid>
            <Grid container spacing={2} sx={{ p: '30px 0px' }}>
              <Grid item xs={12}>
                <Box
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Typography
                    sx={{
                      fontFamily: 'Poppins',
                      fontSize: '24px',
                      fontWeight: 400,
                      color: '#000000',
                    }}
                  >
                    Offer Summary
                  </Typography>
                  <Typography
                    onClick={handleToggle}
                    sx={{
                      border: '1px solid #F0F0F0',
                      padding: '5px 6px',
                      height: '41px',
                      width: '41px',
                      display: 'flex',
                      alignItems: 'center',
                      borderRadius: '5px',
                      cursor: 'pointer',
                    }}
                  >
                    {showOfferSummary ? (
                      <ExpandLessOutlined sx={{ color: '#0065FC' }} />
                    ) : (
                      <ExpandMoreOutlined sx={{ color: '#0065FC' }} />
                    )}
                  </Typography>
                </Box>
              </Grid>
              {showOfferSummary && (
                <Grid container item xs={12} sx={{ alignItems: 'flex-start' }}>
                  <Grid item xs={12} sm={8}>
                    <Grid
                      xs={12}
                      sx={{
                        ...flexStyle,
                        flexDirection: matches500 ? 'column' : 'row',
                        flexWrap: matches600 ? 'wrap' : 'nowrap',
                        alignItems: matches500 ? 'flex-start' : 'center',
                        mb: 5,
                      }}
                    >
                      <Typography
                        sx={{
                          ...reqStyle,
                          width: matches500 ? '100%' : '30%',
                          mb: matches500 ? '8px' : 0,
                          textAlign: matches500 ? 'start' : 'left',
                          color: '#666666',
                          fontWeight: 400,
                        }}
                      >
                        Price:
                      </Typography>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: matches500 ? 'column' : 'row',
                          alignItems: matches500 ? 'flex-start' : 'center',
                          gap: '10px',
                          width: matches500 ? '100%' : 'auto',
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: 'Poppins',
                            fontSize: matches800 ? '12px' : '16px',
                            color: '#000000',
                            fontWeight: 400,
                          }}
                        >
                          {getBuyerIndividualValue?.PropertyDetails
                            ?.privateOfferDetails?.privateOfferPrice
                            ? getBuyerIndividualValue.PropertyDetails
                                .privateOfferDetails.privateOfferPrice
                            : '-'}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid
                      xs={12}
                      sx={{
                        ...flexStyle,
                        flexDirection: matches500 ? 'column' : 'row',
                        flexWrap: matches600 ? 'wrap' : 'nowrap',
                        alignItems: matches500 ? 'flex-start' : 'center',
                        mb: 5,
                      }}
                    >
                      <Typography
                        sx={{
                          ...reqStyle,
                          width: matches500 ? '100%' : '30%',
                          mb: matches500 ? '8px' : 0,
                          textAlign: matches500 ? 'start' : 'left',
                          fontWeight: 400,
                          color: '#666666',
                        }}
                      >
                        Offer Status:
                      </Typography>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: matches500 ? 'column' : 'row',
                          alignItems: matches500 ? 'flex-start' : 'center',
                          gap: '10px',
                          width: matches500 ? '100%' : 'auto',
                        }}
                      >
                        <Typography
                          sx={{
                            display: 'flex',
                            width: '95px',
                            padding: '3px 6px',
                            alignItems: 'flex-start',
                            justifyContent: 'center',
                            gap: '10px',
                            borderRadius: '5px',
                            background:
                              getBuyerIndividualValue?.PropertyDetails
                                ?.privateOfferDetails?.isConditional == 1
                                ? 'rgba(237, 11, 11, 0.60)'
                                : '#10D35E',
                            marginTop: '-2px',
                          }}
                        >
                          <Typography
                            sx={{
                              color: '#FFF',
                              fontFamily: 'Poppins',
                              fontSize: '10px',
                              fontStyle: 'normal',
                              fontWeight: 500,
                              lineHeight: 'normal',
                              textTransform: 'capitalize',
                            }}
                          >
                            {getBuyerIndividualValue?.PropertyDetails
                              ?.privateOfferDetails?.isConditional == 1
                              ? 'Conditional'
                              : 'Unconditional'}
                          </Typography>
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid
                      xs={12}
                      sx={{
                        ...flexStyle,
                        flexDirection: matches500 ? 'column' : 'row',
                        flexWrap: matches600 ? 'wrap' : 'nowrap',
                        alignItems: matches500 ? 'flex-start' : 'center',
                        mb: 5,
                      }}
                    >
                      <Typography
                        sx={{
                          ...reqStyle,
                          width: matches500 ? '100%' : '30%',
                          mb: matches500 ? '8px' : 0,
                          textAlign: matches500 ? 'start' : 'left',
                          color: '#666666',
                          fontWeight: 400,
                        }}
                      >
                        Deposit:
                      </Typography>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: matches500 ? 'column' : 'row',
                          alignItems: matches500 ? 'flex-start' : 'center',
                          gap: '10px',
                          width: matches500 ? '100%' : 'auto',
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: 'Poppins',
                            fontSize: matches800 ? '12px' : '16px',
                            color: '#000000',
                            fontWeight: 400,
                          }}
                        >
                          {`${getBuyerIndividualValue?.PropertyDetails?.privateOfferDetails?.depositAmount}%`}
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid
                      xs={12}
                      sx={{
                        ...flexStyle,
                        flexDirection: matches500 ? 'column' : 'row',
                        flexWrap: matches600 ? 'wrap' : 'nowrap',
                        alignItems: matches500 ? 'flex-start' : 'center',
                      }}
                    >
                      <Typography
                        sx={{
                          ...reqStyle,
                          width: matches500 ? '100%' : '30%',
                          mb: matches500 ? '8px' : 0,
                          textAlign: matches500 ? 'start' : 'left',
                          color: '#666666',
                          fontWeight: 400,
                        }}
                      >
                        Settlement:
                      </Typography>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: matches500 ? 'column' : 'row',
                          alignItems: matches500 ? 'flex-start' : 'center',
                          gap: '10px',
                          width: matches500 ? '100%' : 'auto',
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: 'Poppins',
                            fontSize: matches800 ? '12px' : '16px',
                            color: '#000000',
                            fontWeight: 400,
                          }}
                        >
                          {getBuyerIndividualValue?.PropertyDetails
                            ?.privateOfferDetails?.settlementDays ?? '-'}{' '}
                          {Number(
                            getBuyerIndividualValue?.PropertyDetails
                              ?.privateOfferDetails?.settlementDays
                          ) === 1
                            ? 'day'
                            : 'days'}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
          <Grid
            item
            container
            xs={12}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              border: '1px solid',
              borderColor: '#FF9500',
              padding: 2,
              alignItems: 'center',
              m: '0px 30px',
            }}
          >
            <Grid item xs={1} sx={{ display: 'flex', alignItems: 'center' }}>
              <WarningIconYELLOW fontSize={isXsScreen ? 'small' : 'medium'} />
            </Grid>
            <Grid item xs={11}>
              <Typography
                sx={{ ...poppins400, color: '#666666', fontSize: '16px' }}
              >
                Buyer’s that fail to meet their deposit payment obligations can
                be in breach of their contractual obligations and may face
                serious penalties and or recovery action.
              </Typography>
            </Grid>
          </Grid>
          <Grid sx={{ mt: '20px' }}>
            <Typography
              sx={{
                paddingTop: '8px',
                fontFamily: 'poppins!important',
                fontSize: matchesmd ? '12px' : '16px!important',
                fontWeight: 400,
                color: '#666666',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              Please refer to contract of sale and any agreed amendments for
              full offer details.
            </Typography>
          </Grid>
          <Grid container sx={{ mt: '20px' }}>
            <Grid item>
              <FormControlLabel
                sx={{ alignItems: 'flex-start' }}
                control={
                  <Checkbox
                    checked={firstChecked}
                    onChange={(e) => setFirstChecked(e.target.checked)}
                    icon={CustomCheckIcon}
                    checkedIcon={CustomCheckedIcon}
                    disableRipple
                    sx={{
                      '& .MuiSvgIcon-root': {
                        border: 'none',
                        outline: 'none',
                        boxShadow: 'none',
                        background: 'transparent',
                      },
                    }}
                  />
                }
                label={
                  <Typography
                    sx={{
                      paddingTop: '8px',
                      fontFamily: 'poppins!important',
                      fontSize: matchesmd ? '12px' : '16px!important',
                      fontWeight: 400,
                      color: '#666666',
                      textAlign: 'justify',
                    }}
                  >
                    I acknowledge that while a signed Contract of Sale by both
                    Buyer and Vendor, along with a deposit payment, is required
                    to formalise the exchange, by accepting this Private Offer,
                    an Offer and Acceptance is formed. I understand I am bound
                    to complete the transaction, and that failure to do so may
                    constitute a breach of my contractual obligations, carrying
                    serious legal and financial consequences. Please refer to
                    the Terms and Conditions.
                  </Typography>
                }
              />
            </Grid>
            <Grid item>
              <FormControlLabel
                sx={{ alignItems: 'flex-start' }}
                control={
                  <Checkbox
                    checked={secondChecked}
                    onChange={(e) => setSecondChecked(e.target.checked)}
                    icon={CustomCheckIcon}
                    checkedIcon={CustomCheckedIcon}
                    disableRipple
                    sx={{
                      '& .MuiSvgIcon-root': {
                        border: 'none',
                        outline: 'none',
                        boxShadow: 'none',
                        background: 'transparent',
                      },
                    }}
                  />
                }
                label={
                  <Typography
                    sx={{
                      paddingTop: '8px',
                      fontFamily: 'poppins!important',
                      fontSize: matchesmd ? '12px' : '16px!important',
                      fontWeight: 400,
                      color: '#666666',
                      textAlign: 'justify',
                    }}
                  >
                    I acknowledge and agree to the Terms and Conditions set out
                    by retreX and the selling agent.
                  </Typography>
                }
              />
            </Grid>
          </Grid>

          <Grid
            container
            marginTop={matchessm ? '30px' : '20px'}
            justifyContent={'flex-end'}
            gap={'20px'}
          >
            <Grid
              item
              onClick={() => {
                onClose();
                setPrivateOfferDetailsOpen(true);
              }}
            >
              <Button
                variant="outlined"
                style={{
                  padding: '10px 39px',
                  width: '100%',
                  height: '41px',
                  fontSize: matchesmd ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
              >
                Back
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                disabled={!(firstChecked && secondChecked)}
                onClick={() => {
                  onClose();
                  setPrivateOfferAcceptOpenTwo(true);
                }}
                style={{
                  padding: '10px 39px',
                  width: '100%',
                  height: '41px',
                  fontSize: matchesmd ? '12px' : '14px',
                  backgroundColor: '#4CA4D6',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  borderRadius: '5px',
                  opacity: !(firstChecked && secondChecked) ? 0.5 : 1,
                  cursor: !(firstChecked && secondChecked)
                    ? 'not-allowed'
                    : 'pointer',
                  textTransform: 'none',
                }}
              >
                Accept
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Dialog>
      <PrivateOfferAcceptPopupTwo
        open={privateOfferAcceptOpenTwo}
        onClose={() => setPrivateOfferAcceptOpenTwo(false)}
        getBuyerIndividualValue={getBuyerIndividualValue}
        PopupOneClose={onClose}
        setManageOffer={setManageOffer}
        groupIt={groupIt}
        groupCall={groupCall}
      />
    </>
  );
};
export default PrivateOfferAcceptPopupOne;
